import React, { useState } from 'react';
import { Trash2Icon } from 'lucide-react';

import { Button } from '@epoch-ui/components/Button/button';
import { SheetFooter } from '@epoch-ui/components/Sheet/sheet';
import { Separator } from '@epoch-ui/components/Separator';
import { GuestStatus } from 'types/guest.types';

import { useGuestSideSheetContext } from '../../guestSideSheetContext';
import { PlusOneRsvpControlModal } from '../Modals/PlusOneRsvpControlModal/PlusOneRsvpControlModal';
import { RemovePlusOneConfirmDialog } from '../Modals/RemovePlusOneConfirmDialog';

import { PlusOneRsvpControlDropdown } from './PlusOneRsvpControlDropdown';

export const PlusOneSideSheetFooter = (): React.ReactNode => {
  const { setSelectedPlusOneId, refetchGuestData, handleUpdateRefetch } =
    useGuestSideSheetContext();

  const [openRemoveModal, setOpenRemoveModal] = useState(false);
  const [isRsvpControlModalOpen, setIsRsvpControlModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<GuestStatus | null>(null);

  const goBackToParent = (): void => setSelectedPlusOneId(null);

  const handleStatusSelect = (targetStatus: GuestStatus): void => {
    setSelectedStatus(targetStatus);
    setIsRsvpControlModalOpen(true);
  };

  const handleCloseRsvpControlModal = (): void => {
    setIsRsvpControlModalOpen(false);
    setSelectedStatus(null);
  };

  const handlePlusOneRemoval = (): void => {
    setOpenRemoveModal(false);
    goBackToParent();
    refetchGuestData();
    handleUpdateRefetch();
  };

  const handleRsvpUpdate = (): void => {
    refetchGuestData();
    handleUpdateRefetch();
  };

  return (
    <>
      <Separator className="-tw-mx-6 tw-w-[unset]" />
      <SheetFooter className="tw-sticky tw-bottom-0 tw-justify-between tw-bg-white">
        <PlusOneRsvpControlDropdown onStatusSelect={handleStatusSelect} />
        <Button
          size="xs"
          variant="ghost"
          className="tw-text-destructive-foreground hover:tw-text-destructive-foreground"
          onClick={() => setOpenRemoveModal(true)}
        >
          <Trash2Icon size={16} className="tw-mr-2" />
          Remove
        </Button>
      </SheetFooter>
      {selectedStatus && (
        <PlusOneRsvpControlModal
          open={isRsvpControlModalOpen}
          onOpenChange={handleCloseRsvpControlModal}
          selectedStatus={selectedStatus}
          onRsvpUpdate={handleRsvpUpdate}
        />
      )}
      <RemovePlusOneConfirmDialog
        open={openRemoveModal}
        onOpenChange={setOpenRemoveModal}
        handleRemovePlusOne={handlePlusOneRemoval}
      />
    </>
  );
};
